// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__YhTn+","title":"NotFound_title__htZJO","subtitle":"NotFound_subtitle__+hEtz","goback_button":"NotFound_goback_button__chcJb"};